<template>
    <v-container>
        <v-card>
            <v-card-title> 
                {{ $t("end_eval_title") }}
            </v-card-title>
            <v-card-text
                v-for="keyword in actual_final_keywords"
                :key="keyword[0]"
            >
                <v-divider></v-divider>
                <v-spacer class="pb-8"></v-spacer>

                <span> {{ keyword[0] }} </span>
                <a v-if="keyword[1]" :href="keyword[3]" target="_new"> {{ keyword[2] }} </a>
                <span v-if="keyword[1]"> {{ keyword[4] }} </span>
                
                <v-spacer v-if="keyword[5]" cols='12' class="py-3"></v-spacer>
                <v-divider v-if="keyword[5]" ></v-divider>
                <v-spacer v-if="keyword[5]" cols='12' class="py-3"></v-spacer>
                <v-img v-if="keyword[5]" width="650" height="315" align="center" cols="4" :src="keyword[6]"></v-img>
                
                <v-spacer v-if="keyword[7]" cols='12' class="py-3"></v-spacer>
                <v-divider v-if="keyword[7]" ></v-divider>
                <v-spacer v-if="keyword[7]" cols='12' class="py-3"></v-spacer>
                <iframe v-if="keyword[7]" width="650" height="315" align="center" cols="4" :src="keyword[8]" title="YouTube video player" frameborder="0" allowfullscreen></iframe>

            </v-card-text>
        </v-card>
        <v-spacer cols='12' class="py-3"></v-spacer>
        <v-divider></v-divider>
        <v-spacer cols='12' class="py-3"></v-spacer>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfx5XdfZvf_-Gf0t6PX5GUBk6V132nxbgTgLDiAu6wBOAVrQQ/viewform?embedded=true" width="650" height="315" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        <div>
            <v-container class="pt-7">
                <v-row >
                    <v-col cols="12" @click="$emit('restart')">
                        <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon>mdi-restart</v-icon> {{ $t('restart') }} </v-card>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="12" @click="$emit('go_back')">
                        <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon>mdi-undo</v-icon> {{ $t('go_back') }} </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        
    </v-container>
    
</template>

<script>
import i18n from '../i18n'
import questions from '../questions'
import { extract_links_images_videos } from '../get_link_image_video'
export default {
    name: "endEvaluation",
    props: {
        keywords: Array,
    },
    data: () => ({
        actual_final_keywords: []
    }),
    created() {
        for (let keyword = 0; keyword < this.keywords.length; keyword++) {
            this.actual_final_keywords.push(extract_links_images_videos(this.$t(this.keywords[keyword]))) 
        }
    },
    beforeUpdate() {
        this.actual_final_keywords = []
        for (let keyword = 0; keyword < this.keywords.length; keyword++) {
            this.actual_final_keywords.push(extract_links_images_videos(this.$t(this.keywords[keyword]))) 
        }
    },
}
</script>